import { Wizard } from 'qic-components'

export default class extends Wizard {
  constructor (router, store) {
    super(router, store)
    this.stepCount = 0
    this.appName = 'renew'
  }

  static steps = {
    info: { component: 'MotorPolicyInfo', next: 'change-plan', disableProgress: true },
    'change-plan': { component: 'MotorChangePlan', next: 'quote', disableProgress: true },
    'vehicle-value': { component: 'MotorVehicleValue', next: 'select-scheme', disableProgress: true },
    'select-scheme': { component: 'SelectPlan', next: 'quote', disableProgress: true },
    'quote-reference': { component: 'QuoteReference', disableProgress: true },
    quote: { component: 'Quote', disableProgress: true }
  }
}
